let loadGtagTimer: NodeJS.Timeout | null = null;
let isNotGtag = false;
/**
 * 初始化访问两个页面上报代码
 * @param callback
 */
const initViewMoreThan2Pages = (callback: (eventName: string, eventParams: any) => void) => {
    let pageViewCount = Number(localStorage.getItem('gaPageViewCount'));
    pageViewCount++;
    if (pageViewCount === 3) {
        // 广告转化
        callback('conversion', {
            send_to: 'AW-871914325/YIzgCInN5ssZENW24Z8D',
        });
        // ga 事件
        callback('view_more_than_2_pages', {});
    }
    localStorage.setItem('gaPageViewCount', String(pageViewCount));
};
/**
 * 初始化访问超过1分钟页面上报代码
 * @param callback
 */
const initViewMoreThan1Min = (callback: (eventName: string, eventParams: any) => void) => {
    const currentTotalTime = Number(localStorage.getItem('gaTotalTime')) || 0;
    let timer: NodeJS.Timeout;
    if (currentTotalTime < 60) {
        let totalTime = 0;
        timer = setInterval(function () {
            if (localStorage.getItem('gaTotalTime') != null) {
                totalTime = Number(localStorage.getItem('gaTotalTime')) || 0;
                totalTime++;
                if (totalTime > 60) {
                    clearInterval(timer);
                    return;
                }
                localStorage.setItem('gaTotalTime', String(totalTime));
                if (totalTime == 60) {
                    // 广告转化
                    callback('conversion', {
                        send_to: 'AW-871914325/mF1GCIbN5ssZENW24Z8D',
                    });
                    //GA4
                    callback('view_more_than_1_min', {});
                }
            } else {
                totalTime = 0;
                localStorage.setItem('gaTotalTime', String(totalTime));
            }
        }, 1000);
    }
};

/**
 * @description 轮询获取gtag 是否已经动态插入
 * @returns
 */
const checkGtagLoaded = () => {
    let count = 0;
    return new Promise((res, rej) => {
        // 如果 gtag 未定义，轮询检查,超过1分钟直接暂停
        const interval = setInterval(() => {
            if (window.dataLayer && window.gtag) {
                clearInterval(interval);
                res(true);
            }
            count++;
            // 超过60秒 放弃轮询
            if (count > 30) {
                isNotGtag = true;
                clearInterval(interval);
                rej({ message: 'not gtag' });
            }
        }, 2000); // 每2秒检查一次
    });
};

/**
 * @description 初始化基础分析
 * @param param
 */
export const initBasicAnalysis = async ({
    hasViewMoreThan2Pages,
    hasViewMoreThan1Min,
    callback,
}: {
    hasViewMoreThan2Pages: boolean;
    hasViewMoreThan1Min: boolean;
    callback: (eventName: string, eventParams: any) => void;
}) => {
    // 先轮询获取window.dataLayer & window.gtag 全局变量
    try {
        await checkGtagLoaded();
        hasViewMoreThan2Pages && initViewMoreThan2Pages(callback);
        hasViewMoreThan1Min && initViewMoreThan1Min(callback);
    } catch (e) {
        console.log(e);
    }
};
